import { Link } from "react-router-dom";
import type { Film } from "@/types";
import { filmCategoryMeta } from "@/mocks/categories";
import { useFavorites } from "@/hooks/useFavorites";

interface FilmCardProps {
  film: Film;
  showFavorite?: boolean;
}

export default function FilmCard({ film, showFavorite = true }: FilmCardProps) {
  const { isFavorite, toggleFavorite } = useFavorites();
  const active = isFavorite(film.id);
  const cat = filmCategoryMeta[film.category];

  return (
    <article className="group relative flex flex-col">
      <div className="relative w-full aspect-[2/3] overflow-hidden rounded-lg bg-secondary-100">
        <Link
          to={`/detail/film/${film.id}`}
          className="block w-full h-full"
          aria-label={`查看${film.title}详情`}
        >
          <img
            src={film.cover}
            alt={`${film.title}海报`}
            title={`${film.title} - ${cat.label} - 星光传媒`}
            className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/10 to-transparent" />
          <div className="absolute left-3 top-3 rounded-md bg-foreground-950/55 px-2 py-1 text-xs font-medium text-background-50 backdrop-blur-sm">
            {cat.label}
          </div>
          <div className="absolute right-3 top-3 flex items-center gap-1 rounded-md bg-accent-500 px-2 py-1 text-xs font-semibold text-background-50">
            <i className="ri-star-fill text-[11px]" />
            {film.rating.toFixed(1)}
          </div>
          <div className="absolute inset-x-0 bottom-0 p-3">
            <h3 className="truncate text-sm font-semibold text-background-50 md:text-base">
              {film.title}
            </h3>
            <p className="mt-0.5 truncate text-xs text-background-200">
              {film.genres.join(" · ")} · {film.year}
            </p>
          </div>
        </Link>
        {showFavorite && (
          <button
            type="button"
            onClick={(event) => {
              event.preventDefault();
              toggleFavorite(film.id);
            }}
            aria-label={active ? "取消收藏" : "收藏"}
            className={`absolute bottom-3 right-3 flex h-8 w-8 items-center justify-center rounded-full backdrop-blur-sm transition-colors ${
              active
                ? "bg-accent-500 text-background-50"
                : "bg-foreground-950/45 text-background-50 hover:bg-accent-500"
            }`}
          >
            <i className={active ? "ri-heart-fill text-base" : "ri-heart-line text-base"} />
          </button>
        )}
      </div>
    </article>
  );
}